import React, { FC } from 'react';

interface Props {
  text: string;
  url?: string;
  title?: string;
  className?: string;
  openInNewWindow?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FooterMenuLink: FC<Props> = ({
  text,
  url,
  className,
  openInNewWindow,
}) => {
  return (
    <>
      <li className={`${className}`}>
        <a href={url} target={openInNewWindow ? '_blank' : ''}>
          {text}
        </a>
      </li>
    </>
  );
};

export default FooterMenuLink;
